import React, { createContext, useContext, useState } from 'react';
import en from '../locales/en.json';
import hi from '../locales/hi.json';
import bn from '../locales/bn.json';
import ta from '../locales/ta.json';
import mr from '../locales/mr.json';
import ne from '../locales/ne.json';
import mni from '../locales/mni.json';
import te from '../locales/te.json';
import gu from '../locales/gu.json';
import ur from '../locales/ur.json';
import kn from '../locales/kn.json';
import or from '../locales/or.json';
import ml from '../locales/ml.json';
import pa from '../locales/pa.json';
import as from '../locales/as.json';
import mai from '../locales/mai.json';
import sa from '../locales/sa.json';
import kok from '../locales/kok.json';
import brx from '../locales/brx.json';
import doi from '../locales/doi.json';
import ks from '../locales/ks.json';
import sat from '../locales/sat.json';

const LanguageContext = createContext();

const languages = {
  'English': en,
  'हिन्दी': hi,
  'বাংলা': bn,
  'తెలుగు': te,
  'मराठी': mr,
  'தமிழ்': ta,
  'ગુજરાતી': gu,
  'اردو': ur,
  'ಕನ್ನಡ': kn,
  'ଓଡ଼ିଆ': or,
  'മലയാളം': ml,
  'ਪੰਜਾਬੀ': pa,
  'অসমীয়া': as,
  'मैथिली': mai,
  'संस्कृत': sa,
  'नेपाली': ne,
  'कोंकणी': kok,
  'মণিপুরী': mni,
  'बड़ो': brx,
  'डोगरी': doi,
  'कॉशुर': ks,
  'ᱥᱟᱱᱛᱟᱲᱤ': sat
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'English';
  });
  const [translations, setTranslations] = useState(() => {
    const savedLang = localStorage.getItem('selectedLanguage') || 'English';
    return languages[savedLang] || en;
  });

  const changeLanguage = (language) => {
    setCurrentLanguage(language);
    setTranslations(languages[language] || en);
    localStorage.setItem('selectedLanguage', language);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};